import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

const SignIn = React.lazy(() => import('@/pages/auth/login'))

export const Route = createFileRoute('/_auth/sign-in')({
  component: SignIn,
})
